import { AppBar, Toolbar, useMediaQuery, useTheme } from "@mui/material";

import { FC } from "react";
import { IAppState } from "../../store/reducers";
import { useSelector } from "react-redux";

export interface IBasicTwoColumnLayoutShowOnlyTitleSetupToolbar {
	pageTitle: string
}

export const BasicTwoColumnLayoutShowOnlyTitleSetupToolbar: FC<IBasicTwoColumnLayoutShowOnlyTitleSetupToolbar> = ({
	pageTitle,
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#F7F7F7",
				paddingY: isMobile ? 0 : "10px",
				boxShadow: "none",
				zIndex: theme.zIndex.appBar + 1,
				position: "sticky",
				top: subMenuVisibility ? "112px" : "64px",
			}}
		>
			<Toolbar
				sx={{
					paddingLeft: { xs: 0.2, sm: 1, md: 1, lg: 1, xl: 1 },
					paddingRight: { xs: 0.2, sm: 1, md: 1, lg: 1, xl: 1 },
					minHeight: { sm: "48px", md: "48px", lg: "48px", xl: "48px" },
					fontWeight: "700",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<div style={{ fontSize: isMobile ? "1rem" : "1.5rem", fontWeight: "bold" }}>
					{pageTitle}
				</div>
			</Toolbar>
		</AppBar>
	);
};
